import Component from './Component';
import customtrait from './customtraits';

export default Component.extend({
  defaults: {
    ...Component.prototype.defaults,
    type: 'text',
    droppable: false,
    editable: true,
    unstylable: ['padding'],
    traits: [
      customtrait.bindable,
      customtrait.datasource,
      customtrait.fieldname,
      customtrait.datatype,
      { ...customtrait.actionable, ...{ className: 'topDivider' } },
      customtrait.eventName,
      { ...customtrait.font_property, ...{ className: 'topDivider' } },
      customtrait.font_title,
      { ...customtrait.bg_property, ...{ className: 'topDivider' } },
      customtrait.bg_title
    ]
  },

  toHTML() {
    this.trigger('sync:content', { silent: 1 });
    return Component.prototype.toHTML.apply(this, arguments);
  }
});
